(ns minorodata.components.data-apps.dashboards
  (:require
   ["lucide-react" :refer [ArrowLeft HelpCircle]]
   ["react" :as react]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.data-apps.core :refer [data-app-modal get-modal-data]]
   [minorodata.components.data-apps.dashboard-iframe :refer [dashboard-iframe]]
   [minorodata.components.data-apps.utils :refer [dashboard-routes]]
   [minorodata.components.spinner.core :as components.spinner]
   [minorodata.utils :as utils :refer [find-first]]
   [re-posh.core :as re-posh]
   [reagent.core :as reagent]
   [reitit.frontend.easy :as rt.easy]
   [ui.button :refer [button]]
   [ui.dialog :refer [dialog-actions dialog-close dialog-content
                      dialog-description dialog-root dialog-title
                      dialog-trigger]]
   [ui.page :refer [page-content page-description page-header page-root
                    page-title]]
   [ui.typography :as typography]))


(defn dashboard-not-found []
  [page-root
   [page-content {:class "flex flex-col gap-4 items-center justify-center"}
    [typography/h1 "Dashboard not found"]
    [button {:href (rt.easy/href :data-apps)
             :icon ArrowLeft}
     "Go back"]]])


(defn help-button []
  (let [show? (reagent/atom false)]
    (fn [{:keys [route]}]
      (let [modal-data (get-modal-data route)]
        (when modal-data
          [:<>
           [button {:variant    :link
                    :size       :icon
                    :icon-props {:size 24}
                    :icon       HelpCircle
                    :on-click   #(reset! show? true)}]

           [data-app-modal {:data       modal-data
                            :open       @show?
                            :on-close   #(reset! show? false)}]])))))


(defn get-matching-customer-dashboard [route]
  (let [customer-dashboards @(re-posh/subscribe [:data-app/pull-many])
        stringified-id      (name route)
        matching-dashboard  (utils/find-by-field
                             customer-dashboards
                             :data-app/data-app-id
                             stringified-id)]

    (when matching-dashboard
      {:sigma-url  (:data-app/dashboard-url matching-dashboard)
       :userbacked true})))

(defn create-po [entities]
  (doall
   (for [e entities]
     (case (:type e)
       "extract" (dispatch [:connections.api/start-extract-by-id {:extract-id (:extract-id e)
                                                                  :source-id  (:source-id e)}])
       "transform" (let [{:transform-master/keys [transform]}
                         @(re-posh/subscribe [:transform-master/pull [:transform-master/master-id (:master-id e)] '[{:transform-master/transform [*]}]])]
                     (dispatch [:transform.api/start-by-id {:transform-id (:transform/transform-id transform)}]))
       nil))))

(defn fetch-entities [entities]
  (dispatch [:connections.api/fetch-sources])
  (doall
   (for [{:keys [source-id extract-id master-id type]} entities]
     (case type
       "extract"   (dispatch [:connections.api/fetch-extract {:source-id source-id :extract-id extract-id}])
       "transform" (dispatch [:transform.api/get-latest-version-by-master-id {:master-id master-id}])
       nil))))

(defn extract-button [{:keys [entities]}]
  (let []
    (react/useEffect
     (fn []
       (fetch-entities entities)
       js/undefined)
     #js [entities])

    [dialog-root
     [dialog-trigger {:as-child false}
      [button {:component :div}
       "Create PO"]]

     [dialog-content
      [dialog-title "Confirmation"]
      [dialog-description "Are you sure you want to create the purchase order shown in the preview within your ERP?"]
      [dialog-actions
       [dialog-close {:as-child false}
        [button
         {:component :div
          :on-click  #(create-po entities)}
         "Confirm"]]]]]))

(defn dashboard-page [{:keys [route query]}]
  (let [dashboard (get dashboard-routes route)
        dashboard-override (get-matching-customer-dashboard route)

        loading?       @(re-posh/subscribe [:mold-http/loading? :data-apps.api/fetch-all])
        variants-data (some-> @(re-posh/subscribe [:unleash/get-variant "data-apps.run-extract"])
                              (get-in [:payload :value])
                              js/JSON.parse
                              (js->clj :keywordize-keys true))
        variant-data (find-first #(= (keyword (:data-app %)) route) variants-data)

        showing-demo-dashboard? (:demo-data-app query)

        dashboard (if showing-demo-dashboard?
                    dashboard
                    (merge dashboard dashboard-override))]

    (if-not dashboard
      [dashboard-not-found]

      (let [{:keys [title description icon sigma-id sigma-url userbacked workbook]} dashboard
            sigma-url (if (fn? sigma-url) (sigma-url) sigma-url)
            sigma-id  (if (fn? sigma-id) (sigma-id) sigma-id)]
        [page-root
         [page-header {:content-props {:class "flex gap-2"}}
          [:div [icon]]
          [:div {:class "grow"}
           [page-title {:class "mb-1"} title]
           [page-description description]]
          [:div {:class "flex gap-2 items-start"}
           (when variant-data
             [:f> extract-button {:entities (:entities variant-data)}])
           (when (get dashboard :data-app true)
             [help-button {:route route}])]]

         [page-content {:class "p-0 flex items-stretch"}

          (if loading?
            [:div {:class "top-1/2 relative text-center"}
             [components.spinner/inline-configurable {:size 50}]]

            ^{:key route}
            [dashboard-iframe {:sigma-id   sigma-id
                               :sigma-url  sigma-url
                               :userbacked userbacked
                               :hide-menu  (get dashboard :data-app true)
                               :workbook   workbook}])]]))))
